var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "increase-decimal",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.71,38.71l-7,7c-.2.2-.45.29-.71.29s-.51-.1-.71-.29c-.39-.39-.39-1.02,0-1.41l5.29-5.29h-22.59c-.55,0-1-.45-1-1s.45-1,1-1h22.59l-5.29-5.29c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l7,7c.09.09.17.2.22.32.05.12.08.25.08.38s-.03.26-.08.38c-.05.12-.12.23-.22.32ZM4,22c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2ZM15,26c-3.86,0-7-3.14-7-7v-10c0-3.86,3.14-7,7-7s7,3.14,7,7v10c0,3.86-3.14,7-7,7ZM20,19v-10c0-2.76-2.24-5-5-5s-5,2.24-5,5v10c0,2.76,2.24,5,5,5s5-2.24,5-5ZM25,19v-10c0-3.86,3.14-7,7-7s7,3.14,7,7v10c0,3.86-3.14,7-7,7s-7-3.14-7-7ZM27,19c0,2.76,2.24,5,5,5s5-2.24,5-5v-10c0-2.76-2.24-5-5-5s-5,2.24-5,5v10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumoLogo);
export default __webpack_public_path__ + "static/media/numo-logo.d3d6e3cac3bf8405cfa6fbc8d83dd6b6.svg";
export { ForwardRef as ReactComponent };